export const versionNumber: string = "v1.1.4";
export const appName: string = "Aya Care";
